import styled from 'styled-components';

export const Frame = styled.div`
  width: 100%;
  height: 100%;
  min-height: 180px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: #111827;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
`;
